var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrader = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 20,
  viewBox: "0 0 24 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.98991 9.60099L7.48231 7.49805C7.02672 5.6106 8.4569 3.79413 10.3986 3.79413H20.1015C22.0431 3.79413 23.4733 5.6106 23.0177 7.49805L22.5101 9.60099C22.185 10.948 20.9796 11.8971 19.5939 11.8971H10.9062C9.52046 11.8971 8.31505 10.948 7.98991 9.60099Z",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 1H3.44213C4.8027 1 5.99292 1.91562 6.34182 3.2307L8.79054 12.4605C9.13943 13.7756 10.3297 14.6912 11.6902 14.6912H22.2353",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.897,
  cy: 18.0441,
  r: 1.45588,
  stroke: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.7205,
  cy: 18.0441,
  r: 1.45588,
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrader);
export { ForwardRef as ReactComponent };